export default "__VITE_ASSET__50567564__"